export const environment = {
  production: false,
  apiUrl: 'https://dev-api.colorfol.com',
  siteUrl: 'https://dev-store.colorfol.com',
  shareUrl: 'https://dev-share.colorfol.com',
  stripePublicKey: 'pk_test_51KxGWgAtTDM3AeqSYVtM3gARIH9LhgOo7I7DMceMwzzRN4e4LUi8fCPLLopTs5vUKCHJeLWVUi9OlQGEczd1xpK600y7pp0BrM', // TODO: Replace with your actual Stripe Public Key
  facebookAppId: '1447377979105861',
  appleClientId: 'colortech.colorfol',
  appleRedirectURI: 'https://colorfol.com/auth/apple/callback',
  googleClientId: '1089953404963-tga1aogr06fl8pngepa1fugercs62779.apps.googleusercontent.com'
};
